module.exports = __webpack_public_path__ + "img/_logo-discover.6cf23a80.svg";